import styled from 'styled-components'
import { customMedia } from '../../../utils/breakpoints'


export const CertificationLink = styled.a`
  padding-left: 10px;
  padding-right: 6px;
  text-decoration: underline;
  color: ${props => props.theme.footer.desktop.copyright.text};

    &:visited {
      color: white;
    }

    ${customMedia.lessThan('sm')`
      color: ${props => props.theme.footer.mobile.copyright.text};
      width: 70px;

      &:visited {
        color: ${props => props.theme.footer.mobile.copyright.text};
      }
    `}

    ${customMedia.lessThan('xs')`
      width: 90px;
    `}
`

